import {
  Button,
  NavBar,
  Icon,
  Toast,
  WhiteSpace,
  SearchBar,
  Modal,
} from "antd-mobile";
import res from "antd-mobile-icons/es/AaOutline";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const ToupiaoList = styled.div`
  .body {
    height: 100%;
  }
  .month p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }
`;
export default function VotingDetails() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [starttimeList, setStarttimeList] = useState<{
    time: number;
  }>({ time: 1 });
  const [endtimeList, setEndtimeList] = useState<{
    time: number;
    status: string;
  }>({ time: 1, status: "" });
  const [detailsList, setDetailsList] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const history = useHistory();
  const alert = Modal.alert;
  const [informationList, setInformationList] = useState<{
    uuid: string;
  }>({
    uuid: "",
  });
  useEffect(() => {
    // 获取现在时间
    const nowTime1 = new Date();
    const nowTime = nowTime1.getTime();
    setStarttimeList({
      ...starttimeList,
      time: nowTime,
    });
    // console.log(nowTime);
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    // console.log(tstr);
    let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1];
    setInformationList({
      uuid: tstr1,
    });
    instance
      .post(
        `/oa/adjust/getTransferStaffList?vsheetId=` +
          tstr0 +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        // console.log(resp.data.Data.data);
        // console.log(resp);
        if (resp.data.Status == 1) {
          let arr = resp.data.Data.data;
          let data0 = arr.find((item: any) => item.uuid === tstr1);
          // console.log(data0);
          let staffName = data0.staffName;
          let departmentName = data0.departmentName;
          let curLevel = data0.curLevel;
          let yearPerLevel = data0.yearPerLevel;
          setDetailsList({
            staffName,
            departmentName,
            curLevel,
            yearPerLevel,
          });
        }
      });
    //获取结束时间
    instance.get(`/oa/adjust/getNoticeList`).then((resp) => {
      // console.log(resp);
      // console.log(resp.data.Data.data);
      if (resp.data.Status === "1") {
        let arr1 = resp.data.Data.data;
        let data1 = arr1.find((item: any) => item.uuid === tstr0);
        // console.log(data1);
        const khTime = new Date(data1.调岗或停职轮训投票结束时间).getTime();
        // console.log(khTime);
        //  const Status = data1.status;
        //  setEndtimeList({
        //    ...endtimeList,
        //    time: khTime,
        //    status: Status,
        //  });
      }
    });
  }, []);
  const favor = useCallback(() => {
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    console.log(tstr);
    // let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1];
    instance
      .post(`/oa/adjust/saveTransferVote?result=1&uuid=` + tstr1)
      .then((resp) => {
        console.log(resp);
        if (resp.data.Status == 1) {
          Toast.info(resp.data.Message, 1.5);
        } else {
          Toast.info(resp.data.Message, 1.5);
        }
      });
  }, []);
  return (
    <>
      <ToupiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/rankadjustment/suspension`);
                  history.go(-1);
                }}
              />
            }
          >
            投票详情
          </NavBar>
          <WhiteSpace />
          <div style={{ padding: "10px 20px 10px 20px" }} className="month">
            <p>
              <span>被投票人</span>
              <span>{detailsList.staffName}</span>
            </p>
            <p>
              <span>部门</span>
              <span>{detailsList.departmentName}</span>
            </p>
            <p>
              <span>当前职级</span>
              <span>{detailsList.curLevel}</span>
            </p>
            <p>
              <span>绩效等级</span>
              <span>{detailsList.yearPerLevel}</span>
            </p>
            <p>
              <span>工作报告</span>
              <span>工作报告名</span>
            </p>
          </div>
          <div style={{ padding: "0px 20px 0px 20px", marginTop: 130 }}>
            {/* <Button type="primary">投票</Button><WhiteSpace /> */}
            <Button
              type="primary"
              onClick={() =>
                alert(
                  "提示",
                  "主张对其进行安排调岗或停职轮训请点击赞成，否则点击反对。",
                  [
                    {
                      text: "赞成",
                      onPress: () =>
                        new Promise((resolve) => {
                          favor();
                          setTimeout(resolve, 2000);
                        }),
                    },
                    {
                      text: "反对",
                      onPress: () =>
                        new Promise((resolve) => {
                          Toast.info("投票成功", 1);
                          setTimeout(resolve, 1000);
                        }),
                    },
                  ]
                )
              }
            >
              投票
            </Button>
          </div>
        </div>
      </ToupiaoList>
    </>
  );
}
